export default "__VITE_ASSET__4b1411bf__"